import { useTypedSelector } from 'common/hooks/store';
import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { toggleBlur } from './blurToggleSlice';

const BlurButton: FC<{ buttonClasses: string }> = ({ buttonClasses }) => {
  const { isBlurActive } = useTypedSelector((state) => state.blur);

  const dispatch = useDispatch();

  return (
    <>
      <button onClick={() => dispatch(toggleBlur())} className={buttonClasses}>
        {isBlurActive ? (
          <span className="flex items-center">
            <i className="ra-icons-generic-loupe-1 text-neutral-500 flex mr-2"></i>
            <span className="leading-4">Unblur</span>
          </span>
        ) : (
          <span className="flex items-center">
            <i className="ra-icons-generic-loupe text-neutral-500 flex mr-2"></i>
            <span className="leading-4">Blur</span>
          </span>
        )}
      </button>
    </>
  );
};

export default BlurButton;
